module.exports = __webpack_public_path__ + "img/awaits.e036997d.png";